import { useMemo } from 'react'
import { readRealtimeConfig } from '@/realtime/realtime-config'
import { RealtimeConnectionState, useRealtimeConnectionState } from '@/realtime/realtime-dispatcher'
import { realtimeEnv } from '@/realtime/realtime-env'

const STATE_DOT: Record<RealtimeConnectionState, string> = {
	[RealtimeConnectionState.DISABLED]: 'bg-ds-border-strong',
	[RealtimeConnectionState.IDLE]: 'bg-ds-border-strong',
	[RealtimeConnectionState.CONNECTING]: 'bg-ds-warning',
	[RealtimeConnectionState.RECONNECTING]: 'bg-ds-warning',
	[RealtimeConnectionState.CONNECTED]: 'bg-ds-success',
}

/**
 * Build information in the sidebar footer (TO-468): version, optional hash and
 * stage, plus the realtime topic prefix (or `realtime off`) and a dot whose
 * accessible name is the live connection state.
 */
export function BuildInfoBar() {
	const config = useMemo(() => readRealtimeConfig(realtimeEnv()), [])
	const liveState = useRealtimeConnectionState()
	const state = config ? liveState : RealtimeConnectionState.DISABLED
	const hash = import.meta.env.VITE_APP_VERSION_HASH

	return (
		<div data-testid="build-info-bar" className="px-4 py-1 text-[9px] text-ds-text-subtle flex justify-between gap-2">
			<span>
				v{import.meta.env.VITE_APP_VERSION || '1.0.0'}
				{hash && ` (${hash})`}
			</span>
			<span className="flex items-center gap-1 min-w-0">
				<span className="truncate">{config ? config.topicPrefix : 'realtime off'}</span>
				<span
					role="img"
					aria-label={state}
					title={state}
					className={`inline-block h-1.5 w-1.5 rounded-full ${STATE_DOT[state]}`}
				/>
			</span>
			<span>{import.meta.env.VITE_APP_STAGE || 'local'}</span>
		</div>
	)
}
